import React from "react";
import styled from "styled-components";
import {observer} from "mobx-react";
import {LOCALE, OTHER_LANG_URL} from "modules/constants";
import {SelectProps} from "@mui/material/Select/Select";
import {useStore} from "modules/hooks";

const Wrapper = styled.div`
	position: absolute;
	top: 60px;
	left: 60px;

	z-index: 10;
	@media (max-width: 1000px) {
		top: 48px;
		left: 32px;
	}
`;

const Link = styled.a`
	display: inline-flex;
	transition: all 0.3s ease-out;
	background: #fff;
	gap: 4px;
	height: 32px;
	align-items: center;
	justify-content: center;
	padding: 2px;
	border-radius: 100px;
	color: #888;
	font-family: var(--fontFamilyBase);
	font-feature-settings: "clig" off, "liga" off;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 28px; /* 175% */
	text-transform: uppercase;
`;

const LangChip = styled.span`
	color: #000;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 8px;
	border-radius: 100px;
	&.active {
		background: #0ff;
	}
`;

// const links: Record<string, string> = {
// 	fr: "https://teampicker.cfl.ca/?lang=en",
// 	en: "https://selectionneurequipe.lcf.ca/?lang=fr",
// };

export const LanguageSwitch: React.FC<SelectProps> = observer((props) => {
	const {I18n} = useStore();
	const lang = LOCALE === "fr" ? "en" : "fr";
	return (
		<Wrapper>
			<Link href={`${OTHER_LANG_URL}?lang=${lang}`}>
				<LangChip className={LOCALE === "en" ? "active" : ""}>
					{I18n.t("language.switch.en")}
				</LangChip>
				<LangChip className={LOCALE === "fr" ? "active" : ""}>
					{I18n.t("language.switch.fr")}
				</LangChip>
			</Link>
		</Wrapper>
	);
});
